import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Wallet from './pages/Wallet';
import TokenFactory from './pages/TokenFactory';
import Explorer from './pages/Explorer';
import Mining from './pages/Mining';
import Tokens from './pages/Tokens';
import Whitepaper from './pages/Whitepaper';
import './App.css';
import DeveloperLogin from './pages/DeveloperLogin';
import DeveloperDashboard from './pages/DeveloperDashboard';

function App() {
  return (
    <div className="App min-h-screen bg-background noise-overlay relative">
      <BrowserRouter>
        <div className="flex">
          <Sidebar />
          <main className="flex-1 ml-64">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/token-factory" element={<TokenFactory />} />
              <Route path="/explorer" element={<Explorer />} />
              <Route path="/mining" element={<Mining />} />
              <Route path="/tokens" element={<Tokens />} />
              <Route path="/whitepaper" element={<Whitepaper />} />
              <Route path="/developer/login" element={<DeveloperLogin />} />
              <Route path="/developer/dashboard" element={<DeveloperDashboard />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        theme="dark"
        toastOptions={{
          style: {
            background: '#0F172A',
            color: '#F8FAFC',
            border: '1px solid rgba(0, 240, 255, 0.3)'
          }
        }}
      />
    </div>
  );
}

export default App;
